<template>
  <footer class="bg-white border-t border-gray-200">
    <div class="container px-4 py-12 mx-auto">
      <div class="flex justify-between px-12 md:grid-cols-4">
        <!-- <div class="col-span-1 md:col-span-2">
          <h3 class="mb-4 text-lg font-bold">
            {{ $t("footer.newsletterTitle") }}
          </h3>
          <p class="mb-4 text-sm text-brand-black">
            {{ $t("footer.newsletterDescription") }}
          </p>
          <form class="flex items-center" @submit.prevent>
            <input
              type="email"
              :placeholder="$t('footer.emailPlaceholder')"
              class="px-4 py-2 w-full max-w-xs border-b-2 border-gray-500 transition-colors outline-none focus:border-brand-red"
            />
            <button
              type="submit"
              class="px-6 py-2 ml-4 font-semibold rounded-full border border-gray-500 transition-colors group hover:border-brand-red hover:bg-brand-red"
            >
            <span class="text-gray-600 group-hover:text-white">
              {{ $t("footer.signUp") }}
            </span>
            </button>
          </form>
        </div> -->
        <div>
          <h3 class="mb-4 text-lg font-bold">{{ $t("footer.products") }}</h3>
          <ul class="space-y-2 text-sm text-brand-black">
            <li>
              <a
                href="https://www.top-goodee.com/ac571"
                class="hover:text-brand-red cursor-pointer"
                >AC571</a
              >
            </li>
            <li>
              <a
                
                class="hover:text-brand-red cursor-pointer"
                >AC201</a
              >
            </li>
            <li>
              <a
                href="https://www.top-goodee.com/yg600mini"
                class="hover:text-brand-red cursor-pointer"
                >YG600 Mini</a
              >
            </li>
          </ul>
        </div>
        <div>
          <h3 class="mb-4 text-lg font-bold">{{ $t("footer.support") }}</h3>
          <ul class="space-y-2 text-sm text-brand-black">
            <!-- contactUs -->
            <li>
              <a
                target="_blank"
                @click="jumpTo('/contact-us')"
                class="cursor-pointer text-brand-red"
                >{{ $t("footer.contactUs") }}</a
              >
            </li>

            <!-- FAQ -->
            <li>
              <a
                @click="jumpTo('/sales-questions')"
                class="cursor-pointer hover:text-brand-red"
                >{{ $t("footer.preSales") }}</a
              >
            </li>
            <li>
              <a
                @click="jumpTo('/product-support')"
                class="cursor-pointer hover:text-brand-red"
                >{{ $t("footer.productSupport") }}</a
              >
            </li>
            <!-- <li>
              <a href="#" class="hover:text-brand-red">{{
                $t("footer.afterSales")
              }}</a>
            </li> -->
          </ul>
        </div>
      </div>

      <div
        class="flex flex-col justify-between items-center pt-8 mt-12 text-sm border-t border-gray-200 md:flex-row text-brand-black"
      >
        <div class="flex flex-col gap-y-2 gap-x-6 items-center md:flex-row">
          <span
            href="mailto:service@goodee.hk"
            class="flex gap-2 items-center hover:text-brand-red cursor-pointer"
          >
            <MailIcon /> service@goodee.hk
          </span>
          <div class="flex gap-2 items-center">
            <ClockIcon /> {{ $t("footer.workingHours") }}
          </div>
        </div>
        <div class="flex gap-4 items-center mt-4 md:mt-0">
          <span href="#" class="text-gray-400 hover:text-brand-dark"
            ><FacebookIcon
          /></span>
          <span href="#" class="text-gray-400 hover:text-brand-dark"
            ><LineIcon
          /></span>
          <span href="#" class="text-gray-400 hover:text-brand-dark"
            ><YoutubeIcon
          /></span>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
import {
  MailIcon,
  ClockIcon,
  FacebookIcon,
  LineIcon,
  YoutubeIcon,
} from "./icons/";

export default {
  name: "Footer",
  components: {
    MailIcon,
    ClockIcon,
    FacebookIcon,
    LineIcon,
    YoutubeIcon,
  },
  methods: {
    jumpTo(path) {
      this.$router.push(path);
    },
  },
};
</script>
